var jq = jQuery.noConflict();

// Adding IE11 html classes
var newIEReg = new RegExp("Trident\/([0-9]+)\.0")
var oldIEReg = new RegExp("MSIE ([0-9]+)\.[0-5]+")
var ieVersion = -1;
var match = navigator.userAgent.match(newIEReg);
if(match) {
   ieVersion = parseInt(match[1]) + 4;
}else {
    match = navigator.userAgent.match(oldIEReg)
    if (match) {
       ieVersion = parseInt(match[1]);
    }
}

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

var captchaIDs = {};
function hCaptchaOnLoad() {
    jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey": window.hCaptchaSiteKey,
            "callback": function (token) {
                var input = form.find('input[type="hidden"][name="h-captcha-response"]');
                if (!input.length) {
                    input = jq('<input>', { type: 'hidden', name: 'h-captcha-response' }).appendTo(form);
                }
                input.val(token);
                form.submit();
            }
        });
    });
}
function toggleButtonState (button) {
  var isAriaPressed = button.attr('aria-pressed') === 'true';
  button.attr('aria-pressed', isAriaPressed ? 'false' : 'true');
}
function toggleCollapseState (button) {
  var isAriaExpanded = button.attr('aria-expanded') === 'true';
  button.attr('aria-expanded', isAriaExpanded ? 'false' : 'true');
}

var injector = new SVGInjector().inject(document.querySelectorAll('img[data-src]'));
var perfectScrollbarContainers = jq('[data-perfect-scrollbar]');
if (perfectScrollbarContainers.length) {
    // Lazyloader for timeline tabs and image grids
    var lazyLoadInstances = [];
    // The "lazyLazy" instance of lazyload is used (kinda improperly) 
    // to check when the .horzContainer divs enter the viewport
    var lazyLazy = new LazyLoad({
        elements_selector: "[data-perfect-scrollbar]",
        // When the .horzContainer div enters the viewport...
        callback_enter: function(el) {
            // ...instantiate a new LazyLoad on it
            var oneLL = new LazyLoad({
                container: el
            });
            // Optionally push it in the lazyLoadInstances 
            // array to keep track of the instances
            lazyLoadInstances.push(oneLL);
        }
    });
}else {
    var lazyLoad = new LazyLoad({
        elements_selector: "[data-src]"
    });
}
jq(document).ready(function() {
    
    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
    });
    
    if (ieVersion == 11) {
        jq('html').addClass('ie11');
    }
    // Adding contact anchor to links to Applicants
    if (window.location.pathname.indexOf('/careers/job-categories') !== -1) {
        var $contactBtn = jq('.text .btn').filter(function (i, element) {
            return element.innerHTML == 'Contact Us';
        });
        if ($contactBtn.length) {
            var oldHref = $contactBtn.attr('href');
            $contactBtn.attr('href', oldHref + '#contact');
        }
    }
    
    // Scroll to career search results if we're coming to the page using the job search hero
    if (document.getElementById('app') && window.location.search.indexOf('job_title') !== -1) {
        goToByScroll('#app');
        // Focus the first input for accessibility reasons.
        document.querySelector('#app input').focus();
    }
           
    jq('#language-select').on('change', function (e) {
       window.open(e.target.value); 
    });
    
    jq( ".ir-sidebar" ).click(function() {
      jq( '.ir-sidebar .glyphicon-menu-down' ).toggleClass( "glyphicon-menu-up" );
    });
    
    jq(".ir-sidebar").focusout(function(){
        jq( '.glyphicon' ).removeClass( "glyphicon-menu-up" );
    });
    
    jq('.mobile-nav-trigger').click(function(){
        jq('.main-nav').css('height', 'auto');
    });
    
    //Set Cursor pointer to anything with data-toggle
    jq("*[data-toggle]").css( 'cursor', 'pointer' );
    
    jq('#header.affixed').affix({
        offset:{
            top: 1
        }
    });
    
    // Search button click
    jq('#search-button').click(function (e) {
        jq('.search, .search-form').toggleClass('active');
        toggleButtonState(jq(this));
        jq('.search input').focus();
    });
    
    // HP scroll button
    jq('#see-more').click(function (e) {
        var target = jq('.module').first();
        jq('body,html').animate({
            scrollTop: target.offset().top - jq('#header').height()
        });
    });
    
    //Keyboard functionality for non-interactive elements with role="button"
    //Make sure the element is focusable
    var nonInteractivebuttons = jq('[role="button"]:not(a, button)');
    if (nonInteractivebuttons.length > 0) {
        //Make sure the element has focus
        nonInteractivebuttons.each(function() {
            var isFocusable = jq(this).attr('tabindex');
            if (!isFocusable) jq(this).attr('tabindex', 0);
        });
        //Enter button
        nonInteractivebuttons.keydown(function (event) {
            // The action button is activated by space on the keyup event, but the
            // default action for space is already triggered on keydown. It needs to be
            // prevented to stop scrolling the page before activating the button.
            if (event.keyCode === 32) {
                event.preventDefault();
            }
            // If enter is pressed, activate the button
            else if (event.keyCode === 13) {
                event.preventDefault();
                jq(event.currentTarget).click();
            }    
        });
        //Space button
        nonInteractivebuttons.keyup(function (event) {
            if (event.keyCode === 32) {
                event.preventDefault();
                jq(event.currentTarget).click();
            }    
        });
    }
    
    /**
     * =========== OUR COMPANY > OUR HISTORY TIMELINE ===========
     **/
    // Manage timeline "scroll more" icon state
    var timeline = jq('.module-custom-timeline');
    if (timeline.length) {
        /** This is a slightly modified version of the registerTimelineScrollHandlers method
         * below. This registers event handlers to the first tab on load, while the
         * other method removes/re-registers handlers on tab change.
         **/
        var activeCategory = "corporate";
        var currentFlexRow = timeline.find('.timeline-pane.active .flex-row'),
            scrollRightIcon = jq('.module-custom-timeline .scroll-right'),
            scrollLeftIcon = jq('.module-custom-timeline .scroll-left');
        
        // Scroll right animation
        scrollRightIcon.on('click', function (e) {
            var timelineItemWidth = currentFlexRow.find('.timeline-item').first().width();
            currentFlexRow.stop().animate({scrollLeft: currentFlexRow[0].scrollLeft + timelineItemWidth + 30});
        });
        // Scroll left animation
        scrollLeftIcon.on('click', function (e) {
            var timelineItemWidth = currentFlexRow.find('.timeline-item').first().width();
            currentFlexRow.stop().animate({scrollLeft: currentFlexRow[0].scrollLeft - timelineItemWidth - 30});
        });
        // Manage scroll button visibility on scroll
        currentFlexRow.on('scroll', function (e) {
            if (e.target.scrollLeft == e.target.scrollLeftMax) {
                scrollRightIcon.removeClass('active');
            }else {
                scrollRightIcon.addClass('active');
            }
            if (e.target.scrollLeft > 0) {
                scrollLeftIcon.addClass('active');
            }else {
                scrollLeftIcon.removeClass('active');
            }
        });
        // Manage initial scroll right button visibility
        if (currentFlexRow[0].scrollWidth > currentFlexRow[0].clientWidth) {
            scrollRightIcon.addClass('active');
        }
        // Register tab event handlers
        timeline.find('.nav-tabs a').on('shown.bs.tab', registerTimelineScrollHandlers);
        timeline.find('.show-subtabs-item').click(timelineShowSubtabsHandler);
        timeline.find('.show-subtabs-item').keydown(timelineShowSubtabsHandler);
        timeline.find('a[href="#corporate"]').click(timelineShowSubtabsHandler);
        timeline.find('a[href="#corporate"]').keydown(timelineShowSubtabsHandler);
    }
    
    /**
     * Hides or shows the subtabs in the Corporate section depending on what's been
     * clicked.
     **/
    function timelineShowSubtabsHandler (e) {
        e.preventDefault();
        // If the timeline CTA is clicked in a non-corporate tab, open corpate and show the subnav
        var eventSource = e.currentTarget.getAttribute('data-subtab') ? e.currentTarget.getAttribute('data-subtab') : 'nav-tabs';
        if (activeCategory != 'corporate' && eventSource != 'nav-tabs') {
            timeline.find('a[href="#corporate"]').click();
            
        }   
        if (e.target.hash == '#corporate' && eventSource == 'nav-tabs') {
            jq('a[href="#general"]').click();
             if (jq('.subnav-collapse').hasClass('in')) {
                jq('.module-custom-timeline .subnav-collapse').collapse('hide');
             }
        }else {
            jq('.module-custom-timeline .subnav-collapse').collapse('show');
        }
    }
    
    function registerTimelineScrollHandlers (e) {
        var tabPane = jq(e.target.hash),
            flexRow = tabPane.find('.flex-row'),
            scrollRightIcon = jq('.module-custom-timeline .scroll-right'),
            scrollLeftIcon = jq('.module-custom-timeline .scroll-left');  
        
        activeCategory = e.target.hash.replace('#', '');
            
        scrollRightIcon.off('click');
        // Scroll icon click animation
        scrollRightIcon.on('click', function (e) {
            var timelineItemWidth = tabPane.find('.timeline-item').first().width();
            flexRow.stop().animate({scrollLeft: flexRow[0].scrollLeft + timelineItemWidth + 30});
        });
        scrollLeftIcon.on('click', function (e) {
            var timelineItemWidth = tabPane.find('.timeline-item').first().width();
            flexRow.stop().animate({scrollLeft: flexRow[0].scrollLeft - timelineItemWidth - 30});
        });
        // Manage scroll icon visibility on scroll
        flexRow.on('scroll', function (e) {
            if (e.target.scrollLeft == e.target.scrollLeftMax) {
                scrollRightIcon.removeClass('active');
            }else {
                scrollRightIcon.addClass('active');
            }
            if (e.target.scrollLeft > 0) {
                scrollLeftIcon.addClass('active');
            }else {
                scrollLeftIcon.removeClass('active');
            }
        });
        // Manage scroll right icon visibility
        if (flexRow[0].scrollWidth > flexRow[0].clientWidth) {
            scrollRightIcon.addClass('active');
        }else {
            scrollRightIcon.removeClass('active');
        }
        // Manage scroll left icon visibility
        if (flexRow[0].scrollLeft > 0) {
            scrollLeftIcon.addClass('active');
        }else {
            scrollLeftIcon.removeClass('active');
        }
        
    }
    /**
     * =========== /END OUR COMPANY > OUR HISTORY TIMELINE ===========
     **/
    
    /**
     * =========== PERFECT SCROLLBAR ===========
     **/
    var perfectScrollbarTargets = jq('[data-perfect-scrollbar]');
    if (perfectScrollbarTargets.length) {
        var perfectScrollbars = {};
        perfectScrollbarTargets.each(function (i, el) {
            perfectScrollbars[jq(el).parent()[0].id] = new PerfectScrollbar(el);
        });
    }
    /**
     * Update the scrollbar when the tab loads. This fixes an issue in chrome where
     * the scrollbar thumb width wouldn't generate until you attempted to scroll
     * the active megamenu tab
     **/
    jq('.megamenu a[role="tab"]').on('shown.bs.tab', function(e) {
        var activeTab = jq(e.target.hash)[0];
        perfectScrollbars[activeTab.id].update();
    });
    
    /**
     * =========== /END PERFECT SCROLLBAR ===========
     **/
    
    
    /**
     * =========== HOMEPAGE CONTENT ACCORDIONS ===========
     * 
     * This sets the height of the accordion panel once after the first matchheight completes.
     * This is so that we can move the panels around to allow them to take up the full height of
     * the column when they're expanded.
     **/
    var sideAccordions = jq('.module-content-accordions .panel');
    if (sideAccordions.length && jq(window).width() > 768) {
        jq.fn.matchHeight._afterUpdate = function () {
           jq('.module-content-accordions .collapse-section').trigger('singleMatchHeightUpdate.matchHeight'); 
        };
        jq('.module-content-accordions .collapse-section').on('singleMatchHeightUpdate.matchHeight', function (e) {
            jq('.module-content-accordions .collapse-section').height(jq('.module-content-accordions .collapse-section').height());
            jq(this).unbind('singleMatchHeightUpdate.matchHeight');
        });
            
        sideAccordions.find('.panel-collapse').on('show.bs.collapse hide.bs.collapse', function (e) {
            var currentPanel = jq(e.currentTarget).parent();
            var childIndex = currentPanel.index();
            var panelHeaderHeight = currentPanel.children('a').outerHeight() + 7;
            if (e.type == 'show') {
                jq(e.currentTarget).find('.text').height(sideAccordions.parent().outerHeight() - panelHeaderHeight);
            }
            sideAccordions.each(function () {
                panelHeaderHeight = jq(this).children('a').outerHeight() + 7;
                var shiftDistance = e.type == "show" ? (panelHeaderHeight * childIndex) * -1 : 0;
                jq(this).css('transform', 'translateY(' + shiftDistance + 'px)');
            });
        });
    }
    
    /**
     * =========== /END HOMEPAGE CONTENT ACCORDIONS ===========
     **/
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq('.stats-row-w-percents');
    if(divPercentage.length) {
        jq(document).bind('scroll', function(ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq('.stats-row-w-percents').offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq('.stats-row-w-percents .stat').each(function() {
                    var percDiv = jq(this).find('.number'),
                    svgElm = jq(this).find('.circle'),
                    percentNumber = jq(this).attr('data-percent');
                    svgElm.attr('stroke-dasharray', percentNumber + ', 100');
                    svgElm.addClass('active');
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + '%');
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind('scroll');
            }
        });
    }
    
    var subNav = jq('.sub-navigation.affixed');
    var marketoObserver = null; // Store reference to MutationObserver for cleanup
    var marketoTimeoutIds = []; // Store timeout references for cleanup
    var marketoHandlersInitialized = false; // Prevent multiple initialization
    
    if(subNav.length) {
        // Function to calculate and set the affix offset
        function setAffixOffset() {
            var isCurrentlyAffixed = jq(subNav).hasClass('affix') || jq(subNav).hasClass('affix-top') || jq(subNav).hasClass('affix-bottom');
            var naturalOffset;
            
            if (isCurrentlyAffixed) {
                // Temporarily disable affix to measure natural position
                jq(subNav).removeClass('affix affix-top affix-bottom');
                jq(subNav).css('position', '').css('top', '').css('bottom', '');
                
                // Measure natural position
                naturalOffset = jq(subNav).offset().top - jq("#header").outerHeight();
                
                // Restore affix state
                if (jq(subNav).data('bs.affix')) {
                    jq(subNav).data('bs.affix').options.offset.top = naturalOffset;
                    jq(subNav).data('bs.affix').checkPosition();
                } else {
                    jq(subNav).affix({
                        offset: { 
                            top: naturalOffset
                        }
                    });
                }
            } else {
                // Element not affixed, safe to measure directly
                var offset = jq(subNav).offset().top - jq("#header").outerHeight();
                if (jq(subNav).data('bs.affix')) {
                    jq(subNav).data('bs.affix').options.offset.top = offset;
                } else {
                    jq(subNav).affix({
                        offset: { 
                            top: offset
                        }
                    });
                }
            }
        }
        
        // Set initial offset
        setAffixOffset();
        
        // Enhanced Marketo form event handling with proper cleanup
        function setupMarketoFormHandlers() {
            // Prevent multiple initialization
            if (marketoHandlersInitialized) {
                return;
            }
            
            // Handle form load
            jq(document).on('mktoFormLoaded.marketo', function() {
                jq('.mktoPlaceholder:empty, .mktoFormRow:has(.mktoPlaceholder:empty)').hide();
                marketoTimeoutIds.push(setTimeout(setAffixOffset, 100));
            });
            
            // Handle form field interactions
            jq(document).on('focus.marketo', '.mktoForm input, .mktoForm select, .mktoForm textarea', function() {
                marketoTimeoutIds.push(setTimeout(setAffixOffset, 50));
            });
            
            // Handle form validation and error states
            jq(document).on('blur.marketo', '.mktoForm input, .mktoForm select, .mktoForm textarea', function() {
                marketoTimeoutIds.push(setTimeout(setAffixOffset, 100));
            });
            
            // Handle form field changes (for dynamic content)
            jq(document).on('change.marketo', '.mktoForm input, .mktoForm select, .mktoForm textarea', function() {
                marketoTimeoutIds.push(setTimeout(setAffixOffset, 50));
            });
            
            // Handle form submission states
            jq(document).on('submit.marketo', '.mktoForm', function() {
                marketoTimeoutIds.push(setTimeout(setAffixOffset, 100));
            });
            
            // Setup MutationObserver for dynamic form content changes (replaces deprecated DOMNodeInserted)
            if (!marketoObserver && window.MutationObserver) {
                marketoObserver = new MutationObserver(function(mutations) {
                    var shouldRecalculate = false;
                    
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                            // Check if any added nodes are Marketo form elements or descendants
                            for (var i = 0; i < mutation.addedNodes.length; i++) {
                                var node = mutation.addedNodes[i];
                                if (node.nodeType === 1) { // Element node
                                    if (jq(node).hasClass('mktoForm') || jq(node).find('.mktoForm').length > 0) {
                                        shouldRecalculate = true;
                                        break;
                                    }
                                }
                            }
                        }
                    });
                    
                    if (shouldRecalculate) {
                        marketoTimeoutIds.push(setTimeout(setAffixOffset, 100));
                    }
                });
                
                // Start observing the document for changes
                marketoObserver.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }
            
            marketoHandlersInitialized = true;
        }
        
        // Cleanup function for Marketo handlers
        function cleanupMarketoHandlers() {
            // Remove namespaced event handlers
            jq(document).off('.marketo');
            jq(window).off('resize.marketo');
            
            // Clear all stored timeouts
            marketoTimeoutIds.forEach(function(timeoutId) {
                clearTimeout(timeoutId);
            });
            marketoTimeoutIds = [];
            
            // Disconnect observer
            if (marketoObserver) {
                marketoObserver.disconnect();
                marketoObserver = null;
            }
            
            marketoHandlersInitialized = false;
        }
        
        // Initialize Marketo handlers
        setupMarketoFormHandlers();
        
        // Also recalculate on window resize with namespace
        jq(window).on('resize.marketo', function() {
            marketoTimeoutIds.push(setTimeout(setAffixOffset, 50));
        });
        
        // Fallback: recalculate after a delay to catch any other dynamic content
        marketoTimeoutIds.push(setTimeout(setAffixOffset, 1000));
        
        // Cleanup function to disconnect observer on page unload
        function cleanupMarketoObserver() {
            cleanupMarketoHandlers();
        }
        
        // Disconnect observer on page unload to prevent memory leaks
        jq(window).on('beforeunload', cleanupMarketoObserver);
        jq(window).on('unload', cleanupMarketoObserver);
    }

    var menuRight = document.getElementById( 'mobile-nav' ),
    showRight = document.getElementById( 'showRight' ),
    body = document.body;
    
    if (showRight) {
        showRight.onclick = function() {
            jq(this).toggleClass("active");
            jq('body').toggleClass('push-to-left');
            jq(menuRight).toggleClass("cbp-spmenu-open");
            disableOther( 'showRight' );
            toggleMenuKeybind();
        };
    }
    function disableOther( button ) {
        if( button !== 'showRight' ) {
          jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
    
     function toggleMenuKeybind() {
        var $body = jq('body'),
            $body_events = $body.data("events");
            
        if ($body_events != null && typeof($body_events.keydown) != undefined) {
            $body.off('keydown');
        }else {
        $body.on('keydown', function(e) {
            if (e.which == 27) {
                jq('.main-nav').toggleClass("active");
                jq('body').toggleClass('push-to-left');
                jq(menuRight).toggleClass("cbp-spmenu-open");
                disableOther( 'showRight' );
                $body.off('keydown');
            }
        });
        }
    }
    
    //Email Alerts Form scroll-to functionality upon click
    // jq('#email-alerts-cta-form').on('shown.bs.collapse', function (e) {
    //     jq('html,body').animate({
    //         scrollTop: jq('#email-alerts-cta-form').offset().top -80
    //     }, 500); 
    // }); 

    // Basic Form Validation
    var validator = jq(".validate-form");

    validator.each( function() {
        var formID = jq(this).attr('id');
        jq(this).validate({
            errorPlacement: function(error, element) {
                error.appendTo( element.parent() );
            },
            submitHandler: function(form) {
                if (typeof hcaptcha !== 'undefined' && window.captchaIDs[formID] !== undefined) {
                    if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                        form.submit();
                    } else {
                        hcaptcha.reset(window.captchaIDs[formID]);
                        hcaptcha.execute(window.captchaIDs[formID]);
                    }
                } else {
                    form.submit();
                }
            },
            rules: {
                cookieConsent: {
                    required: true
                }
            },
            messages: {
                cookieConsent: {
                    required: 'You must agree to our policies before you can submit this form'
                }
            }
        });
    });
    
    jq.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test( value );
    }
    
    jq('.toggle-button').click(function() {
        jq(this).toggleClass("open");
    });
    
    jq('.fancybox').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '600'
    });
    jq('.fancybox-sec-filing').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '900'
    });
    
    jq('.fancybox-bio').fancybox({
        minHeight: '0',
        helpers: {
            overlay: {
                locked: true
            }
        },
    });
    
    jq('.fancybox-modal').fancybox({
        width: 970,
        autoSize: false,
        height: 'auto',
        toolbar: true,
        smallBtn: true,
        //Give modal window focus for ADA
        afterLoad: function(current, previous) {
            var content = current.content;
            content.focus();
        },
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: "iframe",
        iframe : {
            css : {
                width : "80%",
                maxWidth: "1024px",
            }
        }
    });
    
    //File input
    var fileInput = jq('.file-text input');
    fileInput.change(function(e){
        $this = jq(this);
        var val = $this.val().split('\\');
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent('.file-text').children('.text-wrapper').text(filename);
    });

    //Video Player
    if (Modernizr.touchevents) {
        jq('body').addClass('touch-device');
        jq('.fancybox,.thickbox').each(function() {
            jq(this).removeClass('thickbox').removeClass('fancybox').attr('target', '_blank');    
        });     
    }

    // SEC Filing Filters - auto submit form
    jq('#sec-filing-filter select').on('change', function(e) {
        jq(this).closest('form').submit(); 
    });
    
    // Brands filter that is ada friendly
    if (jq('.brands-view').length > 0) {
        document.querySelectorAll(".brands-view .nav-tabs li").forEach((item) => {
            item.addEventListener("click", function() {
                let displayId = item.getAttribute("aria-controls");
                if (displayId) {
                    document.querySelectorAll('.brands-view__main-tabs-content.tab-content div').forEach(item => {
                        if (!item.classList.contains('sub-tab-pane')) {
                            item.classList.remove('active');
                        }
                    });
                    let newEle = document.querySelector(`.brands-view__main-tabs-content.tab-content div[id=${displayId}]`);
                    if (newEle) {
                        newEle.classList.add("active")
                    }
                }
            });
        });
    }
    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    function observeForContent(selector) {
        return new Promise((resolve, reject) => {
            let checkInterval = setInterval(() => {
                if (jq(selector).html()) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100); // Check every 100 milliseconds
        });
    }
    function isPrivacyPopupClosed() {
        return getCookie("privacyPopupClosed") === "true";
    }
    
    if (!isPrivacyPopupClosed()) {
        jq(".privacy-popup").css("display", "flex");
    }
    
    jq(".privacy-popup .close-btn").click(function(){
        jq(".privacy-popup").css("display", "none");
        setCookie("privacyPopupClosed", "true", 7); // Set cookie to expire in 7 days
    });
    
    if (jq('body')) {
        observeForContent("#onetrust-banner-sdk")
        .then(() => {
            // perform actions here
            var banner = jq("#onetrust-banner-sdk");
            if (banner.length > 0) {
                var bannerHeight = banner.outerHeight(true);
                jq(".privacy-popup").css("bottom", bannerHeight + "px");
            } else {
                jq(".privacy-popup").css("bottom", "0");
            }
        });
    }

    // GSAP ScrollTrigger for video autoplay
    var gsapRetryCount = 0;
    var maxRetries = 100; // 10 seconds max wait
    var gsapInitStarted = false;
    
    // Helper: Check if autoplay videos exist
    function hasAutoplayVideos() {
        var autoplayVideos = jq('.module-row-video-full iframe[data-should-autoplay="true"], .module-row-video-full video[data-should-autoplay="true"]');
        return autoplayVideos.length > 0;
    }
    
    // Helper: Check if GSAP scripts are present in DOM
    function getGSAPScripts() {
        return {
            gsap: document.querySelector('script[src*="gsap.min.js"]'),
            scrollTrigger: document.querySelector('script[src*="ScrollTrigger.min.js"]')
        };
    }
    
    // Helper: Check if scripts are loaded
    function areScriptsLoaded(gsapScript, stScript) {
        var gsapLoaded = gsapScript.readyState === 'complete' || 
                         gsapScript.readyState === 'loaded' || 
                         gsapScript.readyState === 'interactive';
        var stLoaded = stScript.readyState === 'complete' || 
                       stScript.readyState === 'loaded' || 
                       stScript.readyState === 'interactive';
        return gsapLoaded && stLoaded;
    }
    
    // Helper: Wait for scripts to load
    function waitForScriptsToLoad(gsapScript, stScript, callback) {
        var loadCheck = setInterval(function() {
            var scriptsReady = (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') || 
                              (gsapScript.readyState === 'complete' && stScript.readyState === 'complete');
            
            if (scriptsReady) {
                clearInterval(loadCheck);
                callback();
            }
        }, 50);
        
        setTimeout(function() {
            clearInterval(loadCheck);
        }, 10000);
    }
    
    // Helper: Initialize GSAP and ScrollTrigger
    function initializeGSAP() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            gsapRetryCount++;
            if (gsapRetryCount >= maxRetries) {
                console.error('GSAP: Failed to load after ' + maxRetries + ' attempts.');
                return false;
            }
            setTimeout(initVideoAutoplay, 100);
            return false;
        }
        
        try {
            gsap.registerPlugin(ScrollTrigger);
        } catch (e) {
            console.error('GSAP: Error registering ScrollTrigger:', e);
            return false;
        }
        
        try {
            ScrollTrigger.config({ markers: true });
        } catch (e) {
            console.error('GSAP: Error setting markers config:', e);
        }
        
        return true;
    }
    
    // Helper: Build autoplay URL for iframe
    function buildAutoplayUrl(baseSrc, format) {
        var separator = baseSrc.indexOf('?') !== -1 ? '&' : '?';
        
        if (format === 'youtube' || (format === 'embed' && (baseSrc.indexOf('youtube.com') !== -1 || baseSrc.indexOf('youtu.be') !== -1))) {
            return baseSrc + separator + 'rel=0&modestbranding=1&mute=1&showinfo=0&autoplay=1';
        } else if (format === 'vimeo' || (format === 'embed' && baseSrc.indexOf('vimeo.com') !== -1)) {
            return baseSrc + separator + 'autoplay=1&muted=1&loop=0';
        }
        
        return baseSrc;
    }
    
    // Helper: Create autoplay handler for iframe
    function createIframeAutoplayHandler(iframe, baseSrc, format, shouldAutoplay) {
        var hasAutoplayed = false;
        
        return function() {
            if (!shouldAutoplay || hasAutoplayed) {
                return;
            }
            if (iframe.src.indexOf('autoplay=1') !== -1) {
                hasAutoplayed = true;
                return;
            }
            hasAutoplayed = true;
            iframe.src = buildAutoplayUrl(baseSrc, format);
        };
    }
    
    // Helper: Create autoplay handler for video element
    function createVideoAutoplayHandler(video, shouldAutoplay) {
        var hasAutoplayed = false;
        
        return function() {
            if (!shouldAutoplay || hasAutoplayed) {
                return;
            }
            hasAutoplayed = true;
            video.play().catch(function(error) {
                // Silently handle autoplay restrictions
            });
        };
    }
    
    // Helper: Setup ScrollTrigger for iframe
    function setupIframeScrollTrigger(module, moduleId, iframe) {
        var baseSrc = jq(iframe).data('video-base');
        var format = jq(iframe).data('video-format');
        var shouldAutoplay = jq(iframe).data('should-autoplay') === true || 
                            jq(iframe).data('should-autoplay') === 'true';
        
        var autoplayHandler = createIframeAutoplayHandler(iframe, baseSrc, format, shouldAutoplay);
        
        try {
            ScrollTrigger.create({
                trigger: module,
                start: "center 80%",
                onEnter: autoplayHandler,
                onLeaveBack: function() {},
                invalidateOnRefresh: false,
                id: moduleId + '-iframe'
            });
        } catch (e) {
            console.error('GSAP: Error creating ScrollTrigger for', moduleId, ':', e);
        }
    }
    
    // Helper: Setup ScrollTrigger for video element
    function setupVideoScrollTrigger(module, moduleId, video) {
        var shouldAutoplay = jq(video).data('should-autoplay') === true || 
                            jq(video).data('should-autoplay') === 'true';
        
        var playHandler = createVideoAutoplayHandler(video, shouldAutoplay);
        
        try {
            ScrollTrigger.create({
                trigger: module,
                start: "top 50%",
                onEnter: playHandler,
                onLeaveBack: function() {},
                invalidateOnRefresh: false,
                id: moduleId + '-video'
            });
        } catch (e) {
            console.error('GSAP: Error creating ScrollTrigger for', moduleId, ':', e);
        }
    }
    
    // Helper: Process video modules
    function processVideoModules() {
        var videoModules = jq('.module-row-video-full[id^="row-"]');
        
        if (videoModules.length === 0) {
            return;
        }
        
        videoModules.each(function() {
            var module = this;
            var moduleId = jq(module).attr('id');
            var iframe = jq(module).find('iframe[data-video-base]')[0];
            var video = jq(module).find('video[data-should-autoplay]')[0];
            
            if (iframe) {
                setupIframeScrollTrigger(module, moduleId, iframe);
            } else if (video) {
                setupVideoScrollTrigger(module, moduleId, video);
            }
        });
    }
    
    // Main initialization function (refactored)
    function initVideoAutoplay() {
        if (!hasAutoplayVideos()) {
            return;
        }
        
        var scripts = getGSAPScripts();
        
        if (!gsapInitStarted) {
            gsapInitStarted = true;
            
            if (!scripts.gsap || !scripts.scrollTrigger) {
                console.error('GSAP: Script tags not found! Make sure $page->value("gsap", true) is set in row-video-full.php');
                return;
            }
            
            if (!areScriptsLoaded(scripts.gsap, scripts.scrollTrigger)) {
                waitForScriptsToLoad(scripts.gsap, scripts.scrollTrigger, initVideoAutoplay);
                return;
            }
        }
        
        if (!initializeGSAP()) {
            return;
        }
        
        processVideoModules();
    }
    
    // Start initialization - wait a bit for scripts to potentially load
    setTimeout(function() {
        initVideoAutoplay();
    }, 100);

});

// Quote Box
function populateQuoteBox(quote) {

    if (jq('.ir-quote-box').length > 0) {
        var quoteContainer = jq('.ir-quote-box[data-symbol="' + quote.symbol + '"]');
    } else {
        var quoteContainer = jq('.quote-box[data-symbol="' + quote.symbol + '"]');
        var home_change = true;
    }
        
    var quote_price = checkQuoteProperty(quote.last),
        quote_change = checkQuoteProperty(quote.change),
        quote_change_pct = checkQuoteProperty(quote.change_pct),
        quote_high = checkQuoteProperty(quote.high),
        quote_low = checkQuoteProperty(quote.low),
        quote_day_low = checkQuoteProperty(quote.day_low),
        quote_day_high = checkQuoteProperty(quote.day_high),
        quote_volume = quote.volume;
        // Quotemedia's volume already comes back formatted, so we do not need to custom format it
        if (quote_volume && quote.use_quotemedia !== true) {
            quote_volume = quote_volume.replace(/\,/g,'');
            quote_volume = parseInt(quote_volume,10);
            quote_volume = abbrNum(quote_volume, 2);
        }   
   

    quoteContainer.find('.time').html('<time />');
    quoteContainer.find('time').attr('datetime', quote.last_trade_time).html(quote.last_trade_time);  
    
    
    if (quote_price == 'N/A') {
        quoteContainer.find('.price .value').html('N/A');
    } else {
          quoteContainer.find('.price .value').html('$' + quote_price);
    }

    if (quote.market_cap == 'N/A') {
        quoteContainer.find('.market-cap .value').html('N/A');
    } else {
        quoteContainer.find('.market-cap .value').html('$' + quote.market_cap);
    }
    
     if (quote.volume == null) {
         quoteContainer.find('.volume .value').html('N/A');
     }else {
         quoteContainer.find('.volume .value').html(quote_volume);
     }

    var change = quote_change.replace(/[+|-]/g, '');

    
    quoteContainer.find('.change .value .number').html(change);
    
    if(quote_change_pct != '0.00' && quote_change_pct != 'N/A' && quote_change_pct != '0' ) {
        quoteContainer.find('.change .value .percent').html('(' + quote_change_pct + '%)');
    }
    if (home_change) {
        quoteContainer.find('.change .home-change-value').html(change);
    }

    if (quote.change.indexOf('+') > -1 && change !== '0' && change !== '0.00') {
        quoteContainer.find('.change').addClass('up');
    } else if (quote.change.indexOf('-') > -1) {
        quoteContainer.find('.change').addClass('down');
    }
    
    if (quote.low == quote.high) {
        week = quote_low;    
    } else {
        var week = quote_low + ' - ' + quote_high;         
    }
    quoteContainer.find('.week-range .value').html(week);

    if (quote.day_low != 'N/A' && quote.day_high != 'N/A') {
        if (quote.day_low == quote.day_high) {
            var day = quote_day_low;
        } else {
            day = quote_day_low + ' - ' + quote_day_high;
        }
        quoteContainer.find('.day-range .value').html(day);
    } else {
        quoteContainer.find('.day-range .value').html(quote.last)
    }
    
    jq('.jsrange').jsRange({
        dayLow: quote_day_low,
        dayHigh: quote_day_high,
        yearLow: quote_low,
        yearHigh: quote_high
    });

}

// Equal Heights
jq(window).load(function() {
    checkWidth();
});

function checkQuoteProperty(value) {
    return (value != "N/A") ? parseFloat(value).toFixed(2) : value;
}

function abbrNum(number, decPlaces) {
    var orig = number;
    var dec = decPlaces;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    var abbrev = ["K", "M", "B", "T"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if ((number == 1000) && (i < abbrev.length - 1)) {
                number = 1;
                i++;
            }

            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    return number;
}

// Add commas to numbers
jq.fn.digits = function() {
    return this.each(function() {
        jq(this).text(jq(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    });
};

//Smooth scroll to
function goToByScroll(id, callback, custom_space = 130) {
    if (!jq(id).length) {
        return;
    }
    var subNavHeight = 0;
    var subNav = jq('.sub-navigation.affixed');
    if (subNav.length) {
        subNavHeight = subNav.outerHeight();
    }
    jq('html,body').animate({
        scrollTop: jq(id).offset().top - custom_space - subNavHeight
    }, 'slow', function () {
        if (typeof callback === "function") {
            callback();
        }
    });
}
jq('.smooth').click(function() {
    goToByScroll(jq(this).attr('href'));
    return false;
});

jq(window).ready(function() {
    if (window.location.hash) {
        goToByScroll(window.location.hash,null,-150);          
    }
});

//Check Width
var resizeTimer;
jq(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWidth, 250);
});

function checkWidth() {
    if (jq(window).width() > 767) {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).addClass('active');
        });
        sameHeight();
    } else {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).removeClass('active');
        });
        jq(".js-same-height,.js-same-height-row .js-height").css('min-height', '').css('height', '');
    }
    if (jq(window).width() < 769) {
        jq('.fancybox').each(function() {
            jq(this).addClass('fancybox-holder').removeClass('fancybox');
        });
        jq('.thickbox').each(function() {
            jq(this).addClass('thickbox-holder').removeClass('thickbox');
        });
    } else {
        jq('.fancybox-holder').each(function() {
            jq(this).addClass('fancybox').removeClass('fancybox-holder');
        });
        jq('.thickbox-holder').each(function() {
            jq(this).addClass('thickbox').removeClass('thickbox-holder');
        });
    }

}

//Match Height With Delay for Qmod. Add class same-height to elements
if (isQmod) {    
    var matchHeightInterval;

    matchHeightInterval = setInterval(matchHeightDelay, 50);
    
    function matchHeightDelay()
    {
        if (jq('.qmod-ui-tool, .stock-section').length == 0) return;
        jq('.ir-quote-box img').load(function() {
            jq.fn.matchHeight._apply(jq('.ir-quote-box [data-mh]'));
        });
        jq('.same-height').matchHeight(); 
        clearInterval(matchHeightInterval);
    }
}


// Same Height
function sameHeight() {
    jq(".js-same-height-row").each(function() {
        var $maxHeight = 0,
            $window_width = jq(window).width();
        jq('.js-same-height', this).css({
            'height': 'auto',
            'min-height': 0
        });
        if ((jq(this).data('cutoff') && jq(this).data('cutoff') >= $window_width) || $window_width < 768) {
            return false;
        }
        jq('.js-same-height', this).each(function() {
            if (jq(this).outerHeight() > $maxHeight) {
                $maxHeight = jq(this).outerHeight();
            }
        }).css('min-height', $maxHeight);
        jq('.js-height', this).css({
            'height': $maxHeight,
            'min-height': 0
        });
    });
}

// Fixes XBRL Filing Close Button click event being unbound by an early call to tb_remove
jq(document).ajaxComplete(function() {
    jq('#TB_closeAjaxWindow #TB_closeWindowButton').on('mousedown', function(e) {
        e.preventDefault();
        tb_remove();
    });
    jq('#TB_closeAjaxWindow #TB_closeWindowButton').on('click', function(e) {
        e.preventDefault();
    });
});

// Checkbox Groups
var update_sec_checkboxes = function() {
    if (jq('#ir-sec-all').is(':checked')) {
        jq(".ir-sec-sub").prop('checked', true).prop('disabled', true);
    } else {
        jq(".ir-sec-sub").prop('disabled', false).prop('checked', false);
    }
}
jq('#ir-sec-all').change(update_sec_checkboxes);
if (jq('#ir-sec-all').is(':checked')) {
    jq(".ir-sec-sub").prop('checked', true).prop('disabled', true);
}

//BS Select Accessibility/ARIA 
jq(document).on('rendered.bs.select', function(event) {
    var select = event.target
    var selectId = select.id;
    var menuButton = select.nextSibling.firstChild;
    //Give the button an id
    menuButton.setAttribute('id', selectId + '-button');
    //Set the id of the menu
    var selectMenu = jq(select.nextSibling).find('ul');
    if (selectMenu) {
        //Give the menu an id to set ARIA controls
        selectMenu.attr('id', selectId + '-menu');
        menuButton.setAttribute('aria-controls', selectId + '-menu');
        selectMenu.attr('aria-labelledby', selectId + '-button');

    }
});
// On dropdown open
jq(document).on('shown.bs.dropdown', function(event) {
    var dropdown = jq(event.target);
    // Set aria-expanded to true
    dropdown.find('.dropdown-menu').attr('aria-expanded', true);
    // Set focus on the first link in the dropdown
    setTimeout(function() {
        dropdown.find('.dropdown-menu li:first-child a').focus();
    }, 10);
});

// On dropdown close
jq(document).on('hidden.bs.dropdown', function(event) {
    var dropdown = jq(event.target);
    // Set aria-expanded to false        
    dropdown.find('.dropdown-menu').attr('aria-expanded', false);
    // Set focus back to dropdown toggle
    dropdown.find('.dropdown-toggle').focus();
});
if (jq('#wrap_slider').length > 0 ) {
jq('#wrap_slider').slick({
          infinite: true,
          dots: true,
          variableWidth: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: jq('.prev-slide'),
          nextArrow: jq('.next-slide'),
          appendDots: ".dots-container",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
                slidesToScroll: 1
              }
            }
          ]
    });
}
if (jq('#news_slider').length > 0) {
    jq('#news_slider').slick({
          infinite: true,
          dots: false,
          variableWidth: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
                slidesToScroll: 1
              }
            }
          ]
    });    
}
if (jq('#blue_experts_slider').length > 0) {
    jq('#blue_experts_slider').slick({
          infinite: true,
          dots: false,
          variableWidth: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
                slidesToScroll: 1
              }
            }
          ]
    });    
}
if (jq('#blue_upcoming_events').length > 0) {
    console.log("worked");
    jq('#blue_upcoming_events').slick({
          infinite: true,
          dots: false,
          variableWidth: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
                slidesToScroll: 1
              }
            }
          ]
    });    
}
if (jq('.spotlight-slider').length > 0) {
    jq('.spotlight-slider').slick({
          infinite: true,
          dots: true,
          variableWidth: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
    });    
}
// Job Categories Slider
if (jq('.job-categories-slider').length > 0) {
    jq('.job-categories-slider').slick({
        infinite: true,
        dots: false,
        variableWidth: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                variableWidth: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
                slidesToScroll: 1
              }
            }
          ]
    });
}
//Video Play/Pause Buttons
var videoBtns = document.querySelectorAll('.video-control-btn');
videoBtns.forEach(function(el) {
    // get video id from attribute 'data-target'
    var targetVideo = document.getElementById(el.dataset.target);
    if (targetVideo) {
      jq(el).click(function(e) {
        if (targetVideo.paused) {
          targetVideo.play();
          //Controls don't show by default to match designs
          //On play, we need to hide the designed play/pause button and shows the controls
          if (targetVideo.classList.contains('show-controls-on-play')) {
            el.classList.add('hide');  
            targetVideo.setAttribute('controls', '');
          }
          el.setAttribute('aria-label', 'Pause Video');
        } else {
          targetVideo.pause();
          el.setAttribute('aria-label', 'Play Video');
        }
        el.classList.toggle('paused');
      });
    }
    
});